import { apiFetch } from '../lib/api';

export type PortalAppFieldRecord = {
  name: string;
  value: string;
};

export type PortalAppRecord = {
  id: string;
  name: string;
  url: string;
  iconSrc: string;
  fields: PortalAppFieldRecord[];
  createdAt: string;
  updatedAt: string;
};

export type UpsertPortalAppInput = {
  name: string;
  url: string;
  iconSrc: string;
  fields: PortalAppFieldRecord[];
};

export async function fetchPortalApps() {
  return apiFetch<{ apps: PortalAppRecord[] }>('/api/admin/apps');
}

export async function createPortalApp(input: UpsertPortalAppInput) {
  return apiFetch<{ app: PortalAppRecord }>('/api/admin/apps', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}

export async function updatePortalApp(appId: string, input: UpsertPortalAppInput) {
  return apiFetch<{ app: PortalAppRecord }>(`/api/admin/apps/${encodeURIComponent(appId)}`, {
    method: 'PATCH',
    body: JSON.stringify(input),
  });
}

export async function deletePortalApp(appId: string) {
  return apiFetch<{ ok: boolean }>(`/api/admin/apps/${encodeURIComponent(appId)}`, {
    method: 'DELETE',
  });
}
